import CustomerAlertsPage from './customer-alerts-page'

export default CustomerAlertsPage
